import { Component, OnInit } from '@angular/core';
import { Jobs } from '../../models/jobs.model';
import { CandidatesJobsApply } from '../../models/candidatesJobsApply.model';
import { FunctionsService } from '../../services/functions.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from '../../services/http.service';
import Swal from 'sweetalert2';
import { UsersService } from '../../services/users.service';
import { Professions } from '../../models/professions.model';
import { Trainings } from '../../models/trainings.model';
import { Candidates } from '../../models/candidates.model';
import { Languages } from '../../models/languages.model';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-candidate-apply-job',
  templateUrl: './candidate-apply-job.component.html',
  styleUrls: ['./candidate-apply-job.component.scss']
})
export class CandidateApplyJobComponent implements OnInit {
  jobID: any;
  job: Jobs = new Jobs({});
  isLoading: boolean = false;
  candidatesJobsApply: CandidatesJobsApply[] = [];
  userType: any
  companyId: any;
  eligibility_rate: any = '';
  profession: any = '';
  level_of_study: any = '';
  years_of_experience: any = '';
  position_level: any = '';
  training: any = '';
  language_level: any = '';
  professionList: Professions[] = [];
  trainingList: Trainings[] = [];
  languageList: any[] = [];
  candidateJobApplySelected: CandidatesJobsApply[] = [];
  candidateIDSelected: any[] = [];

  baseURL = environment.apiUrl;

  constructor(public functionsService: FunctionsService, private usersService: UsersService, private router: Router, private route: ActivatedRoute, private httpService: HttpService) {
    this.userType = this.usersService.getUserType();
    this.companyId = (this.usersService.getCurrentUser() != null) ? this.usersService.getCurrentUser().getId() : 0;
    this.jobID = this.route.snapshot.paramMap.get('jobID');
    if (parseInt(this.jobID) != this.jobID) {
      this.router.navigate(['/not-found']);
    }
  }

  ngOnInit() {
    console.log(this.jobID);
    localStorage.removeItem('profile-candidat');
    this.getJob();
    this.getCandidatesJobApply(this.jobID);
    this.trainingList = this.functionsService.getTrainingsList();
    this.formatLanguage();
  }


  exportRepport() {
    this.isLoading = true;
    console.log(this.jobID);
    this.httpService.generateRepport(this.jobID).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let filepath = this.baseURL + '/download/' + response.data;

          this.isLoading = false;
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Votre fichier est à présent disponible.',
            confirmButtonText: 'Télécharger'
          }).then(() => {
            window.open(filepath, "", "width=300, height=300");
          });
        }
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        });
      }
    );

  }

  exportToExcel() {

    if (this.candidateJobApplySelected.length == 0) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Veuillez sélectionner au moins une ligne.',
      });
    } else {
      this.isLoading = true;

      this.httpService.generateToExcel('candidat', this.candidateIDSelected.toString(), this.jobID).subscribe(
        (response: any) => {
          if (response.status == "success") {
            let filepath = this.baseURL + '/download/' + response.data;

            this.isLoading = false;
            Swal.fire({
              icon: 'success',
              title: 'Excellent !',
              text: 'Votre fichier est à présent disponible.',
              confirmButtonText: 'Télécharger'
            }).then(() => {
              window.open(filepath, "", "width=300, height=300");
            });
          }
        },
        (error) => {
          this.isLoading = false;
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          });
        }
      );
    }

  }




  formatLanguage() {
    const languages = this.functionsService.getLanguagesList();
    const levels = ['Débutant', 'Intermédiaire', 'Excellente maitrise']

    languages.forEach((language: Languages) => {
      levels.forEach((level: string) => {
        let langue = {
          id: language.getId() + '-' + level,
          libelle: language.getLibelle() + '-' + level,
        };

        this.languageList.push(langue);
      });
    });
  }

  searchCandidatesApplyJob() {
    this.isLoading = true;
    let form: any = {
      job_id: this.jobID,
      eligibility_rate: this.eligibility_rate,
      level_of_study: this.level_of_study,
      years_of_experience: this.years_of_experience,
      position_level: this.position_level,
      training: this.training,
      language_level: this.language_level
    };


    this.httpService.searchCandidatesJobApply(form).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let list = response.data.list;
          this.candidatesJobsApply = [];
          list.forEach((element: any) => {
            this.candidatesJobsApply.push(new CandidatesJobsApply(element));
          });
          this.isLoading = false;
        }
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        });
      }
    );
  }

  selectedRow(id: any, source: any) {
    if (id == 'all') {
      let rowSelected: any = document.getElementById("checkbox_" + id);
      const rowChecked = (source == 'checkbox') ? !rowSelected.checked : rowSelected.checked
      if (rowChecked == false) {
        this.candidateJobApplySelected = [];
        this.candidatesJobsApply.forEach((candidateJobApply: CandidatesJobsApply) => {
          let currentRow: any = document.getElementById("checkbox_" + candidateJobApply.getId());
          currentRow.checked = true;
          this.addInCandidateJobApplySelectedList(candidateJobApply);
        });
      } else {
        this.candidatesJobsApply.forEach((candidate: CandidatesJobsApply) => {
          let currentRow: any = document.getElementById("checkbox_" + candidate.getId());
          currentRow.checked = false;
          this.candidateJobApplySelected = [];
        });
      }
    } else {
      let rowSelected: any = document.getElementById("checkbox_" + id);
      const rowChecked = rowSelected.checked
      if (rowChecked == false) {
        this.addInCandidateJobApplySelectedList(this.findCandidateJobApply(id));
        rowSelected.checked = true;
      } else {
        this.removeInCandidateJobApplySelectedList(this.findCandidateJobApply(id));
        rowSelected.checked = false;
      }
    }
  }

  addInCandidateJobApplySelectedList(candidateToAdd: CandidatesJobsApply) {
    const list = this.candidateJobApplySelected;
    let inList = false;

    for (let index = 0; index < list.length; index++) {
      const candidateJobApply: CandidatesJobsApply = list[index];

      if (candidateToAdd.getId() == candidateJobApply.getId()) {
        inList = true;
        break;
      }
    }

    if (!inList) {
      this.candidateJobApplySelected.push(candidateToAdd);
      this.candidateIDSelected.push(candidateToAdd.getId());
    }
  }

  removeInCandidateJobApplySelectedList(candidateToRemove: CandidatesJobsApply) {
    const list = this.candidateJobApplySelected;
    let indexOfCandidate = -1;

    for (let index = 0; index < list.length; index++) {
      const candidateJobApply: CandidatesJobsApply = list[index];

      if (candidateToRemove.getId() == candidateJobApply.getId()) {
        indexOfCandidate = index;
        break;
      }
    }

    if (indexOfCandidate != -1) {
      this.candidateJobApplySelected.splice(indexOfCandidate, 1);
      this.candidateIDSelected.splice(indexOfCandidate, 1);
    }
  }

  findCandidateJobApply(candidateJobApplyID: number): CandidatesJobsApply {
    for (let index = 0; index < this.candidatesJobsApply.length; index++) {
      const candidateJobApply = this.candidatesJobsApply[index];

      if (candidateJobApply.getId() == candidateJobApplyID) {
        return candidateJobApply;
      }

    }

    return new CandidatesJobsApply({});

  }

  getCandidatesJobApply(jobID: number) {
    this.isLoading = true;

    this.httpService.getCandidatesJobApply(jobID).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let list = response.data.list;
          list.forEach((element: any) => {
            this.candidatesJobsApply.push(new CandidatesJobsApply(element));
          });
          this.isLoading = false;
        }
      },
      (error: any) => {
        this.isLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }

  getCandidateProfile(candidateID: number) {
    this.candidatesJobsApply.forEach(element => {
      const candidatesJobsApply = new CandidatesJobsApply(element);
      if (candidatesJobsApply.getCandidates().getId() == candidateID) {
        localStorage.setItem('back-url', '/candidats-offre/' + this.jobID);
        localStorage.setItem('profile-candidat', JSON.stringify(candidatesJobsApply.getCandidates()));
        this.router.navigate(['profile-candidat', candidateID]);
      }
    });
  }

  calculateAge(dateBirth: any) {
    const currentDate = new Date().getTime();
    const dateOfBirth = new Date(dateBirth).getTime();
    const age = (currentDate - dateOfBirth) / (365 * 24 * 60 * 60 * 1000);
    return Math.floor(age);
  }

  getJob() {
    if (localStorage.getItem('job') && localStorage.getItem('job') != undefined) {
      const data = JSON.parse(localStorage.getItem('job') || "");
      this.job = new Jobs(data);
    }
  }

}
